import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'card-not-found-dialog',
    templateUrl: './cardNotFoundDialog.component.html',
    styleUrls: ['./cardNotFoundDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CardNotFoundDialogComponent {
    data: any;

    constructor(
        public matDialogRef: MatDialogRef<CardNotFoundDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
    ) {
        this.data = _data.data;
    }

}
